import { serviceReviewsPath } from "@travily/routes";
import type ListingsReviewsNew from "@travily/types/pages/ListingsReviewsNew";
import type { ReactNode } from "react";
import { ReviewFormModal } from "@/components/ReviewFormModal";
import { ServiceReviewNewView } from "./new.view";

const ServiceReviewNewPage = ({ listing_sqid, grant_token, name_required }: ListingsReviewsNew) => (
  <ServiceReviewNewView>
    <ReviewFormModal grantToken={grant_token} nameRequired={name_required} path={serviceReviewsPath(listing_sqid)} />
  </ServiceReviewNewView>
);

ServiceReviewNewPage.layout = (page: ReactNode) => page;

export default ServiceReviewNewPage;
